import Vuex from "vuex";
import Vue from "vue";
import axios from 'axios';

let store;

if (! document.querySelector('#wizard-page')) {
    Vue.use(Vuex);

    store = new Vuex.Store({
        state: {
            schools: [],
            filter: '',
            provinces: [],
            filterProvince: '',
            formData: {
                name: '',
                surname: '',
                dni: '',
                province: '',
                school: '',
                phone: '',
                email: '',
                dateOfBirth: '',
                address: '',
                'city': '',
                postalCode: '',
                titleType: '',
                titleId: null,
                purpose: '',
                titleAmount: null,
                taxesAmount: null,
                text: ''
            },
            validForm: false,

        },

        getters: {
            filter(state){
                return state.filter;
            },
            schoolsFiltered(state, getters){
                return state.filter != '' ? getters.schools : getters.schools;
            },
            provinces(state){
                return state.provinces;
            },
            schoolsFilteredByProvince(state, getters){
                let schools = getters.filterProvince === '' ?
                state.provinces.flatMap(province => province.schools) :
                state.provinces.filter(province => province.id == state.filterProvince)[0].schools;
                return schools;
            },
            filterProvince(state){
                return state.filterProvince;
            },
            getFormData(state){
                return state.formData;
            },
            validForm(state){
                return state.validForm
            }
        },

        mutations: {
            setSchools(state, payload){
                state.schools = [...payload];
            },
            setFilter(state, payload){
                state.filter = {...payload};
            },
            setResources(state, payload){
                state.provinces = [...payload];
            },
            setFilterProvince(state, payload){
                state.filterProvince = payload;
                state.formData.province = state.provinces.filter(province => province.id == payload)[0].name;
            },
            setSchool(state, payload){
                state.formData.school = payload;
            },
            setParamFromFormData(state, payload){
                state.formData[payload.param] = payload.value
            },
            setValidForm(state, payload){
                state.validForm = payload;
            }
        },

        actions: {
            fetchSchools(context){
                axios.get('/api/schools').then((res) => {
                    commit('setSchools', res.data.data);
                }).catch(err => {
                    console.log(err);
                })
            },
            loadResources(context){
                axios.get('/api/resources')
                .then(res => {
                    context.commit('setResources', res.data);
                }).catch(err => {
                console.log(err);

                })
            }
        }
    });
}

export { store };
